import { Grid, Paper, Box, Typography, Link } from "@mui/material";
import React from "react";

import { ReactComponent as FacebookIcon } from "../../../../assets/img/icons/bxl-facebook.svg";
import { ReactComponent as TwitterIcon } from "../../../../assets/img/icons/bxl-twitter.svg";
import { ReactComponent as InstagramIcon } from "../../../../assets/img/icons/instagram-logo.svg";
import { ReactComponent as YoutubeIcon } from "../../../../assets/img/icons/youtube-logo.svg";
// import logo from "../../../../assets/img/TravelPic.png";
import "./footer.css";
import logo from "../../../../assets/img/logo.jpeg";

export default function Footer(props) {
  return (
    <footer style={{ backgroundColor: "white" }}>
      <Grid
        container
        width="70%"
        margin="0 auto"
        padding="2.5rem 0"
        borderBottom="1px solid #eaeaea"
      >
        <Grid xs={12} sm={12} md={3}>
          <Typography
            fontWeight="900"
            align="left"
            variant="h6"
            fontSize="1.5rem"
            className="icon-heading"
          >
            <img src={logo} width={"200"} height={"auto"} alt="Travel Pick" />
          </Typography>
          <Box
            display="flex"
            className="icons-container"
            gap="1.5rem"
            marginTop="2.5rem"
            marginLeft="20px"
          >
            <FacebookIcon />
            <TwitterIcon />
            <InstagramIcon />
            <YoutubeIcon />
          </Box>
        </Grid>
        <Grid xs={6} sm={6} md={3} className="footer-items">
          <Typography
            fontWeight="500"
            align="left"
            fontSize="1.15rem !important"
            color="#1A1A1A"
          >
            COMPANY
          </Typography>
          <Grid
            display="flex"
            flexDirection="column"
            gap="0.25rem"
            marginTop="1.25rem"
          >
            <Link
              underline="none"
              color="#1a1a1a"
              className="link-item"
              href="/aboutus"
            >
              About us
            </Link>
            <Link
              underline="none"
              color="#1a1a1a"
              className="link-item"
              href="privacyPolicy"
            >
              Privacy Policy
            </Link>
            <Link
              underline="none"
              color="#1a1a1a"
              className="link-item"
              href="/terms"
            >
              Terms of Use
            </Link>
          </Grid>
        </Grid>
        <Grid xs={6} sm={6} md={3} className="footer-items">
          <Typography
            fontWeight="500"
            align="left"
            fontSize="1.15rem !important"
            color="#1A1A1A"
          >
            PLATFORM
          </Typography>
          <Grid
            display="flex"
            flexDirection="column"
            gap="0.25rem"
            marginTop="1.25rem"
          >
            <Link
              underline="none"
              color="#1a1a1a"
              className="link-item"
              href="/travelhack"
            >
              Travel Hacks
            </Link>
            <Link
              underline="none"
              color="#1a1a1a"
              className="link-item"
              href="/vendor/login"
            >
              Agent Login
            </Link>
            <Link
              underline="none"
              color="#1a1a1a"
              className="link-item"
              href="/admin/login"
            >
              Admin Login
            </Link>
          </Grid>
        </Grid>
        <Grid xs={6} sm={6} md={3} className="footer-items">
          <Typography
            fontWeight="500"
            align="left"
            fontSize="1.15rem !important"
            color="#1A1A1A"
          >
            HELP & SUPPORT
          </Typography>
          <Grid
            display="flex"
            flexDirection="column"
            gap="0.25rem"
            marginTop="1.25rem"
          >
            <Link
              underline="none"
              color="#1a1a1a"
              className="link-item"
              href="/contactus"
            >
              Contact us
            </Link>
            {/* <Link underline="none" color="#1a1a1a" className="link-item">
              Refund
            </Link>
            <Link underline="none" color="#1a1a1a" className="link-item">
              Help
            </Link> */}
          </Grid>
        </Grid>
      </Grid>
      <Grid width="80%" margin="2.5rem auto">
        <Typography>© 2025 Tripworks | All Rights Reserved</Typography>
      </Grid>
    </footer>
  );
}
